module.exports = __webpack_public_path__ + "static/media/top5-buenos-aires.2a865e3f.md";